import { useEffect, useState } from "react";
import { v4 as UUID } from "uuid";
import { Notification } from "../../interface/functionalityInterface";
import { NotificationProps } from "../../interface/propTypesInterface";
import "./NotificationUnit.scss";

export default function NotificationUnit(props: Notification) {
  const [notifications, setNotifications] = useState<
    (NotificationProps & { expended: boolean })[]
  >([]);

  useEffect(() => {
    if (!props.message || !props.type) return;
    const removeExpendedNotifications = notifications.filter(
      (n) => !n.expended
    );
    setNotifications([
      ...removeExpendedNotifications,
      { ...props, expended: false, id: UUID() },
    ]);
  }, [props]);

  const handleSetExpendedState = (id: string) => {
    setNotifications(
      notifications.map((n) => (n.id === id ? { ...n, expended: true } : n))
    );
  };

  return (
    <div className="notification">
      <div className="notification__container">
        {notifications.map((n) => {
          return (
            <NotificationBanner
              key={n.id}
              {...n}
              expended={handleSetExpendedState}
            />
          );
        })}
      </div>
    </div>
  );
}

function NotificationBanner(
  props: NotificationProps & { expended: (id: string) => void }
) {
  useEffect(() => {
    const elem = document.getElementById(props.id);
    elem?.classList.add("show");
    const animationTimer = setTimeout(() => {
      elem?.classList.remove("show");
      props.expended(props.id);
      // setTimeout(() => {
      //   props.unload(props.id);
      // }, 300);
    }, 3000);
    return () => {
      clearTimeout(animationTimer);
    };
  }, []);
  const handleClose = () => {
    const elem = document.getElementById(props.id);
    elem?.classList.remove("show");
    props.expended(props.id);
  };

  return (
    <div className={`notification__banner ${props.type}`} id={props.id}>
      <button className="close-button" onClick={handleClose}></button>
      <p>{props.message}</p>
      <span>
        {props.type === "WARNING"
          ? "!"
          : props.type === "ERROR"
          ? "X"
          : props.type === "INFORMATION"
          ? "?"
          : props.type === "SUCCESS"
          ? "+"
          : ""}
      </span>
    </div>
  );
}
